import { generate } from '@/utils/request';
const config = {
  prefix: 'sord/v1/{organizationId}',
  items: [
    // 获取询价数据
    { key: 'gateWayRating', url: '/order/order-rate', method: 'POST',loadingHide: true, },
  ],
};
export default {
  ...generate(config),
};
